import { NativeModules, Platform } from 'react-native';

const LINKING_ERROR =
  `The package 'react-native-v2ray-module' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

const V2rayModule = NativeModules.V2rayModule  ? NativeModules.V2rayModule  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

export function multiply(a: number, b: number): Promise<number> {
  return V2rayModule.multiply(a, b);
}
